var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, computed, observable, when, makeObservable } from 'mobx';
import API from '../util/ApiUtil';
import { MandateType } from '../config/mandate';
class DebtStore {
    constructor(rootStore) {
        Object.defineProperty(this, "isInDebt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UNINITALIZED'
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "mandateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "handleSuccess", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (response) => {
                this.status = 'FETCHED';
                this.isInDebt = response.data.debtSum > 0;
            }
        });
        Object.defineProperty(this, "handleError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (error) => {
                this.status = 'ERROR';
                console.error(error);
            }
        });
        makeObservable(this);
        this.ssoStore = rootStore.ssoStore;
        this.mandateStore = rootStore.mandateStore;
    }
    async init() {
        when(() => this.ssoStore.loggedIn && this.mandateStore.hasMandate([MandateType.LEGAL, MandateType.BILLING], false), () => this.getDebt());
    }
    async getDebt() {
        this.status = 'FETCHING';
        API.get('/debt', { withCredentials: true }).then(this.handleSuccess).catch(this.handleError);
    }
    get debtLoaded() {
        return this.status === 'FETCHED';
    }
}
__decorate([
    observable
], DebtStore.prototype, "isInDebt", void 0);
__decorate([
    observable
], DebtStore.prototype, "status", void 0);
__decorate([
    action.bound
], DebtStore.prototype, "init", null);
__decorate([
    action.bound
], DebtStore.prototype, "getDebt", null);
__decorate([
    action.bound
], DebtStore.prototype, "handleSuccess", void 0);
__decorate([
    action.bound
], DebtStore.prototype, "handleError", void 0);
__decorate([
    computed
], DebtStore.prototype, "debtLoaded", null);
export default DebtStore;
